import React from 'react';
import FormGroupWrapper from '../blocks/FormGroupWrapper';

type Props = {
  id: string;
  label: string;
  name: string;
  onChange: (event: any) => void;
  value: number | string;
  type?: string;
  step?: number | string;
  min?: number | string;
  groupClass?: string;
  required?: boolean;
  autocompleteOff?: boolean;
};

const Input = (props: Props): React.ReactElement => {
  const {
    id, label, type, onChange, value, name, required, groupClass, step, min,
    autocompleteOff,
  } = props;

  return (
    <FormGroupWrapper groupClasses={groupClass}>
      <label htmlFor={id} className="col-form-label">{label}</label>
      <input
        type={type || 'text'}
        className="form-control"
        id={id}
        name={name}
        required={required}
        value={value}
        step={step}
        min={min}
        onChange={onChange}
        autoComplete={autocompleteOff ? 'new-password' : ''}
      />
    </FormGroupWrapper>
  );
};

export default Input;
